import { useSetting } from "@/hooks/useSetting";
import { FC, useCallback, useEffect, useState } from "react";

import imgSetup from "@/assets/streamelements-setup.png";

export const StreamElements: FC = () => {
    const [jwt, setJwt] = useSetting("streamelements-jwt");
    const [value, setValue] = useState<string | undefined>(jwt);

    useEffect(() => {
        setValue(jwt);
    }, [jwt]);

    const handleSave = useCallback(() => {
        setJwt(value);
    }, [value, setJwt]);

    return (
        <div className="max-h-screen min-w-xl flex flex-col items-center justify-center">
            <h1 className="text-4xl text-center" aria-label="StreamElements Setup">
                StreamElements Setup
            </h1>
            <p className="text-center mt-4">
                To set up the StreamElements integration, you need to paste the <strong>JWT token</strong> from your <a href="https://streamelements.com/dashboard/account/channels" target="_blank" rel="noopener noreferrer" className="underline">StreamElements channel settings</a> below:<br/>
            </p>
            <div className="flex flex-row items-center justify-center mt-4 w-full max-w-md">
                <input
                    type="text"
                    className="p-2 border rounded w-full max-w-md"
                    placeholder="Enter your StreamElements JWT token"
                    value={value ?? ""}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button
                    className="ml-2 px-4 py-2 bg-violet-500 text-white rounded hover:bg-violet-600 transition"
                    onClick={handleSave}
                >
                    Save
                </button>
            </div>
            <p className="text-center mt-4">
                You can find this token in your StreamElements channel settings under the "JWT Token" section.<br/>
            </p>
            <img src={imgSetup} alt="Screenshot showing where to find the StreamElements JWT token in the StreamElements account settings" className="w-1/2 mt-12 rounded shadow-lg" />
            <p className="text-center mt-4">
                After entering the token, your overlay should be able to receive donations from StreamElements.<br/>
                <br/>
                You can test the integration by emulating a donation in <a href="https://streamelements.com/dashboard/overlays" target="_blank" rel="noopener noreferrer" className="underline">any of your overlays</a>. If everything is set up correctly, the Donation-Train should trigger and Donation-Goals should update accordingly.
            </p>
        </div>
    );
}